import React, { useRef, useState } from "react";
const ShowMoreOptions = ({
  showPayerOption,
  ChangePayer,
  row,
  setAgentId,
  setShowMoreOption,
  showMoreOption,
  setShowPayerOption,
  agentId,
  ResendInviteImage,
  cancelInvite,
  setIsCardDetails,
  setDeleteModel,
  resendInvite,
  setInviteCode,
  setShowRemoveModel,
  changePayer,
  changePayerValue,
}) => {
  const toggleMenu = () => {
    setShowMoreOption(showPayerOption ? false : !showMoreOption);
    setAgentId(row?.Id);
    setShowPayerOption(false);
  };
  const [menuPosition, setMenuPosition] = useState({ top: 0 });
  const ref = useRef(null);
  const handleEllipsisButtonClick = (event) => {
    const ellipsisButtonRect = ref.current.getBoundingClientRect();
    const y = event.clientY - ellipsisButtonRect.bottom;

    setMenuPosition({
      top: y,
    });
    toggleMenu();
  };

  const handleMouseLeave = () => {
    setShowMoreOption(false);
    setShowPayerOption(false);
    // setAgentId(null);
  };

  return (
    <div
      className="show-more-options text-right"
      onMouseLeave={() => handleMouseLeave()}
    >
      <span
        className={"cursor-pointer pl-1"}
        onClick={(e) => handleEllipsisButtonClick(e)}
        ref={ref}
      >
        <svg
          version="1.1"
          width="3px"
          height="17px"
          xmlns="http://www.w3.org/2000/svg"
          //className="mx-3"
          style={{marginLeft: "31px"}}
        >
          <g transform="matrix(1 0 0 1 -1540 -431 )">
            <path
              d="M 2.346449999999999 16.628124999999997  C 2.1107666666666667 16.876041666666666  1.8274333333333317 17  1.4964500000000012 17  C 1.1654833333333343 17  0.8833333333333346 16.874784375000004  0.6500000000000004 16.624353125000003  C 0.4166666666666696 16.373939583333335  0.3000000000000025 16.07289791666667  0.3000000000000007 15.721228125  C 0.3000000000000025 15.369576041666672  0.4178500000000014 15.06979166666667  0.653550000000001 14.821875000000002  C 0.8892333333333351 14.573958333333335  1.1725666666666683 14.450000000000001  1.5035500000000006 14.450000000000001  C 1.8345166666666675 14.450000000000001  2.116666666666667 14.575215625000006  2.3500000000000014 14.825646875  C 2.5833333333333357 15.076060416666675  2.700000000000001 15.37710208333334  2.700000000000001 15.728771875000001  C 2.700000000000001 16.080423958333338  2.582150000000002 16.38020833333334  2.346449999999999 16.628124999999997  Z M 2.346449999999999 9.403125  C 2.1107666666666667 9.651041666666668  1.8274333333333317 9.775  1.4964500000000012 9.775  C 1.1654833333333343 9.775  0.8833333333333346 9.649784375000003  0.6500000000000004 9.399353125  C 0.4166666666666696 9.148939583333334  0.3000000000000025 8.84789791666667  0.3000000000000007 8.496228125  C 0.3000000000000025 8.144576041666665  0.4178500000000014 7.844791666666668  0.653550000000001 7.596875000000001  C 0.8892333333333351 7.348958333333337  1.1725666666666683 7.2250000000000005  1.5035500000000006 7.2250000000000005  C 1.8345166666666675 7.2250000000000005  2.116666666666667 7.3502156250000015  2.3500000000000014 7.600646875000001  C 2.5833333333333357 7.851060416666669  2.700000000000001 8.152102083333336  2.700000000000001 8.503771875000002  C 2.700000000000001 8.855423958333335  2.582150000000002 9.155208333333336  2.346449999999999 9.403125  Z M 2.346449999999999 2.1781250000000005  C 2.1107666666666667 2.426041666666668  1.8274333333333317 2.5500000000000003  1.4964500000000012 2.5500000000000003  C 1.1654833333333343 2.5500000000000003  0.8833333333333346 2.4247843749999998  0.6500000000000004 2.174353125  C 0.4166666666666696 1.9239395833333344  0.3000000000000025 1.622897916666668  0.3000000000000007 1.2712281250000004  C 0.3000000000000025 0.9195760416666661  0.4178500000000014 0.6197916666666673  0.653550000000001 0.3718749999999996  C 0.8892333333333351 0.12395833333333384  1.1725666666666683 0  1.5035500000000006 0  C 1.8345166666666675 0  2.116666666666667 0.12521562499999978  2.3500000000000014 0.37564687500000027  C 2.5833333333333357 0.6260604166666678  2.700000000000001 0.9271020833333334  2.700000000000001 1.278771875  C 2.700000000000001 1.6304239583333335  2.582150000000002 1.930208333333333  2.346449999999999 2.1781250000000005  Z "
              fillRule="nonzero"
              // fill={
              //   !row.PaymentDone && row.PaymentByManager && row.PaymentRequired
              //     ? "#f00"
              //     : "#797979"
              // }
              fill="#797979"
              stroke="none"
              transform="matrix(1 0 0 1 1540 431 )"
            />
          </g>
        </svg>
      </span>
      <div
        className={`options text-left ${
          showMoreOption && row.Id === agentId ? " d-block" : "d-none"
        }`}
        style={{ top: menuPosition.top }}
      >
        {/* {!row.PaymentDone && row.PaymentByManager && row.PaymentRequired ? (
          <ul>
            <li
              className="dropdown-item-list"
              onClick={() => {
                setAgentId(row?.Id);
                setIsCardDetails(true);
                setShowMoreOption(false);
              }}
            >
              <img
                className="mr-2"
                src={"/assets/images/payNow.png"}
                alt=""
                width={8}
                height={15}
              />
              <span className="txt-light-black">{"Make Payment"}</span>
            </li>
            <li
              className="dropdown-item-list"
              onClick={() => {
                setDeleteModel(true);
                setAgentId(row?.Id);
                setShowMoreOption(false);
              }}
            >
              <svg
                className=" material-icons delete-draft cursor-icon mr-2"
                width="13px"
                height="15px"
              >
                <g transform="matrix(1 0 0 1 -1086 -343 )">
                  <path
                    d="M 4.642857142857143 5.625  C 4.642857142857143 5.625  4.642857142857143 11.71875  4.642857142857143 11.71875  C 4.642857142857143 11.976562505587935  4.433928576963289 12.1875  4.178571428571429 12.1875  C 3.9232142801795686 12.1875  3.714285714285714 11.976562505587935  3.714285714285714 11.71875  C 3.714285714285714 11.71875  3.714285714285714 5.625  3.714285714285714 5.625  C 3.714285714285714 5.3671874944120646  3.9232142801795686 5.15625  4.178571428571429 5.15625  C 4.433928576963289 5.15625  4.642857142857143 5.3671874944120646  4.642857142857143 5.625  Z M 6.964285714285715 5.625  C 6.964285714285715 5.625  6.964285714285715 11.71875  6.964285714285715 11.71875  C 6.964285714285715 11.976562505587935  6.75535714839186 12.1875  6.5 12.1875  C 6.24464285160814 12.1875  6.035714285714286 11.976562505587935  6.035714285714286 11.71875  C 6.035714285714286 11.71875  6.035714285714286 5.625  6.035714285714286 5.625  C 6.035714285714286 5.3671874944120646  6.24464285160814 5.15625  6.5 5.15625  C 6.75535714839186 5.15625  6.964285714285715 5.3671874944120646  6.964285714285715 5.625  Z M 9.285714285714286 5.625  C 9.285714285714286 5.625  9.285714285714286 11.71875  9.285714285714286 11.71875  C 9.285714285714286 11.976562505587935  9.076785719820432 12.1875  8.821428571428571 12.1875  C 8.56607142303671 12.1875  8.357142857142858 11.976562505587935  8.357142857142858 11.71875  C 8.357142857142858 11.71875  8.357142857142858 5.625  8.357142857142858 5.625  C 8.357142857142858 5.3671874944120646  8.56607142303671 5.15625  8.821428571428571 5.15625  C 9.076785719820432 5.15625  9.285714285714286 5.3671874944120646  9.285714285714286 5.625  Z M 9.213169642857142 0.7306640781462193  L 10.278125354221888 2.34375  C 10.278125354221888 2.34375  12.303571428571429 2.34375  12.303571428571429 2.34375  C 12.689508934106145 2.34375  13 2.65869140625  13 3.046875  C 13 3.4365234430879354  12.689508934106145 3.75  12.303571428571429 3.75  C 12.303571428571429 3.75  12.071428571428571 3.75  12.071428571428571 3.75  C 12.071428571428571 3.75  12.071428571428571 12.65625  12.071428571428571 12.65625  C 12.071428571428571 13.951171897351742  11.032589307853154 15  9.75 15  C 9.75 15  3.25 15  3.25 15  C 1.9679910625730244 15  0.9285714285714285 13.951171897351742  0.9285714285714285 12.65625  C 0.9285714285714285 12.65625  0.9285714285714285 3.75  0.9285714285714285 3.75  C 0.9285714285714285 3.75  0.6964285714285714 3.75  0.6964285714285714 3.75  C 0.3119419642857142 3.75  0 3.4365234430879354  0 3.046875  C 0 2.65869140625  0.3119419642857142 2.34375  0.6964285714285714 2.34375  C 0.6964285714285714 2.34375  2.72245534828731 2.34375  2.72245534828731 2.34375  C 2.72245534828731 2.34375  3.7868303571428577 0.7306640781462193  3.7868303571428577 0.7306640781462193  C 4.088616060359137 0.2741308696568012  4.596428726400648 0  5.139062677110944 0  C 5.139062677110944 0  7.860937322889055 0  7.860937322889055 0  C 8.403571273599352 0  8.911383939640862 0.2741601783782244  9.213169642857142 0.7306640781462193  Z M 4.947544642857143 1.5105469152331352  C 4.947544642857143 1.5105469152331352  4.396205357142858 2.34375  4.396205357142858 2.34375  L 8.603794642857142 2.34375  C 8.603794642857142 2.34375  8.052455357142858 1.5105469152331352  8.052455357142858 1.5105469152331352  C 8.008928571428571 1.445507851894945  7.9363837486931255 1.40625  7.860937322889055 1.40625  C 7.860937322889055 1.40625  5.139062677110944 1.40625  5.139062677110944 1.40625  C 5.0636162513068745 1.40625  4.964955357834697 1.445507851894945  4.947544642857143 1.5105469152331352  Z M 2.3214285714285716 3.75  C 2.3214285714285716 3.75  2.3214285714285716 12.65625  2.3214285714285716 12.65625  C 2.3214285714285716 13.174804709851742  2.7372544620718275 13.59375  3.25 13.59375  C 3.25 13.59375  9.75 13.59375  9.75 13.59375  C 10.263616093567439 13.59375  10.678571428571429 13.174804709851742  10.678571428571429 12.65625  C 10.678571428571429 12.65625  10.678571428571429 3.75  10.678571428571429 3.75  L 2.3214285714285716 3.75  Z "
                    fillRule="nonzero"
                    fill="#9b9b9b"
                    stroke="none"
                    transform="matrix(1 0 0 1 1086 343 )"
                  ></path>
                </g>
              </svg>
              <span className="txt-light-black">{"Remove agent"}</span>
            </li>
          </ul>
        ) : ( */}
        <ul>
          <li
            className="dropdown-item-list"
            onClick={() => {
              resendInvite(row);
              setShowMoreOption(false);
            }}
          >
            <img className="mr-2" src={ResendInviteImage} alt="" />
            <span className="txt-light-black">{`Resend Invite (${row.email})`}</span>
          </li>
          <li
            className="dropdown-item-list"
            onClick={() => {
              setShowRemoveModel(true);
              setInviteCode(row?.RepresentativeCode);
              setShowMoreOption(false);
            }}
          >
            <img className="mr-2" src={cancelInvite} alt="" />
            <span className="txt-light-black">{"Cancel Invite"}</span>
          </li>
          {/* <li
            className="dropdown-item-list"
            onClick={() => {
              setShowMoreOption(false);
              setShowPayerOption(true);
            }}
          >
            <img className="mr-2" src={ChangePayer} alt="" />
            <span className="txt-light-black">{"Change Payer"}</span>
          </li> */}
        </ul>
        {/* )} */}
      </div>

      <div
        className={`options text-left ${
          showPayerOption && row.Id === agentId ? " d-block" : "d-none"
        }`}
        style={{ top: menuPosition.top }}
      >
        <ul>
          <li
            className="dropdown-item-list"
            onClick={() => {
              changePayer(row, "free");
              setShowMoreOption(false);
              setShowPayerOption(false);
            }}
          >
            <span className="txt-light-black">
              {`Use free invite (${changePayerValue?.freeAcountRemaining} invites remaining)`}
            </span>
          </li>
          <li
            className="dropdown-item-list"
            onClick={() => {
              changePayer(row, "manager");
              setShowMoreOption(false);
              setShowPayerOption(false);
            }}
          >
            <span className="txt-light-black">
              {`Billed to Agency (Added to your subscription for $${changePayerValue?.freeChildPrice}/month)`}
            </span>
          </li>
          <li
            className="dropdown-item-list"
            onClick={() => {
              changePayer(row, "agent");
              setShowMoreOption(false);
              setShowPayerOption(false);
            }}
          >
            <span className="txt-light-black">
              {`Billed to Agent ($${changePayerValue?.freeChildPrice}/month)`}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ShowMoreOptions;
